import SocialAuthRedirectHandles from 'src/routes/SocialAuthRedirectHandles';

SocialAuthRedirectHandles();
